/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core'

import Add from '@material-ui/icons/Add'

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#f50157',
        },
      },
})

class AddButton extends Component {
    state = {
        anchor_el : null,
        menu_open : false
    }

    handleMenuOpen = (event) => {
        this.setState({...this.state, anchor_el : event.currentTarget, menu_open : true })
    }

    handleMenuClose = () => {
        this.setState({...this.state, anchor_el : null, menu_open : false })
    }

    renderButton = () => {
        if (this.props.role === 'trigger') {
            return this.renderTriggerButton()
        } else {
            return this.renderActionButton()
        }
    }

    renderTriggerButton = () => {
        return (
            <Fragment>
                <Tooltip title = {'Add ' + this.props.tag}>
                    <IconButton size = 'small' color = 'primary' onClick = {this.handleMenuOpen} disabled = {this.props.disabled}>
                        <Add/>
                    </IconButton>
                </Tooltip>
                <Menu
                    id="choose-trigger-op"
                    anchorEl={this.state.anchor_el}
                    open={this.state.menu_open}
                    onClose = {this.handleMenuClose}
                >
                    <MenuItem onClick = {() => {
                        this.props.addBoolOp(this.props.cur_id, this.props.step, this.props.index, 'boolean')
                        this.handleMenuClose()
                    }}>Boolean</MenuItem>
                    <MenuItem onClick = {() => {
                        this.props.addBoolOp(this.props.cur_id, this.props.step, this.props.index, 'condition')
                        this.handleMenuClose()
                    }}>Condition</MenuItem>
                </Menu>
            </Fragment>
        )
    }

    renderActionButton = () => {
        return (
            <Fragment>
                <Tooltip title = {'Add ' + this.props.tag}>
                    <IconButton size = 'small' color = 'primary' onClick = {() => this.props.addAction()} disabled = {this.props.disabled}>
                        <Add/>
                    </IconButton>
                </Tooltip>
            </Fragment>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderButton()}
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(AddButton);